import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "@cleartrip/bento";
import { FlyinHeader } from "components/composite";

const isFlyin = () =>{
  if(window.location.href.includes('me.flyin.com') || window.location.href.includes('www.flyin.com')){
    return true;
  }
  return false;
}

const isEGFlyin = () =>{
  if(window.location.href.includes('meeg.flyin.com') || window.location.href.includes('eg.flyin.com')){
    return true;
  }
  return false;
}

const RestRefreshTermsPage = () => {
  useEffect(() => {
    const defaultFavicon = "https://ui.cltp.co/images/icons/favicon.ico";
    const flyinFavicon = "https://me.flyin.com/common/themes/v2/img/favicon.ico";
  
    let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = (isFlyin() || isEGFlyin) ? flyinFavicon : defaultFavicon;
  
    document.head.appendChild(link);
    return () => {
      link.href = defaultFavicon;
      document.head.appendChild(link);
    };
  }, []);

  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      {/* Use the existing FlyinHeader component */}
      <FlyinHeader lng="en" />
      
      {/* Terms and Conditions Content */}
      <Container>
        <Row className="mt-6 mb-8">
          <Col>
            <Card className="p-6 shadow-sm">
              <h1 style={{ 
                color: "#0F4C81", 
                fontSize: "28px", 
                marginBottom: "24px",
                textAlign: "center" 
              }}>
                Rest & Refresh By Flyin - Terms and Conditions
              </h1>
              
              <section style={{ marginBottom: "32px" }}>
                <h2 style={{ 
                  color: "#0F4C81", 
                  fontSize: "20px", 
                  borderBottom: "1px solid #eaeaea",
                  paddingBottom: "8px",
                  marginBottom: "16px" 
                }}>
                  Eligibility
                </h2>
                <ul style={{ 
                  listStyleType: "disc", 
                  paddingLeft: "24px",
                  lineHeight: "1.6",
                  color: "#333333"
                }}>
                  <li>The "Rest & Refresh By Flyin" reimbursement program is applicable only to customers who have booked their flights through Flyin.com</li>
                  <li>The program is valid only for flights that are delayed within six (6) hours of the originally scheduled departure time.</li>
                  <li>The minimum delay required to be eligible for reimbursement is sixty (60) minutes from the originally scheduled departure time.</li>
                  <li>The reimbursement is applicable only for Refreshments consumed / Lounge access at the city of departure.</li>
                  <li>The offer is available to all Flyin customers who have purchased the Rest & Refresh product, subject to verification and compliance with these terms.</li>
                </ul>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h2 style={{ 
                  color: "#0F4C81", 
                  fontSize: "20px", 
                  borderBottom: "1px solid #eaeaea",
                  paddingBottom: "8px",
                  marginBottom: "16px" 
                }}>
                  Reimbursement Details
                </h2>
                <ul style={{ 
                  listStyleType: "disc", 
                  paddingLeft: "24px",
                  lineHeight: "1.6",
                  color: "#333333"
                }}>
                 <li>Flyin will reimburse the amount spent on lounge access up to a maximum limit of {isFlyin() ? "SAR 250":""}{isEGFlyin() ? "EGP 3500":""} per customer per affected flight.</li>
                  <li>In case no lounge is available at the airport of departure, Flyin will reimburse the actual amount spent on refreshments at the airport, subject to the same cap of {isFlyin() ? "SAR 250":""}{isEGFlyin() ? "EGP 3500":""}.</li>
                  <li>The reimbursement will be credited to the customer's Flyin Wallet or Original mode of payment.</li>
                  <li>Reimbursement requests must be submitted within seven (7) days from the date of the delayed flight.</li>
                </ul>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h2 style={{ 
                  color: "#0F4C81", 
                  fontSize: "20px", 
                  borderBottom: "1px solid #eaeaea",
                  paddingBottom: "8px",
                  marginBottom: "16px" 
                }}>
                  Required Documents for Reimbursement
                </h2>
                <ul style={{ 
                  listStyleType: "disc", 
                  paddingLeft: "24px",
                  lineHeight: "1.6",
                  color: "#333333"
                }}>
                  <li>A valid copy of the lounge access receipt or refreshment bill clearly indicating the amount paid.</li>
                  <li>A copy of the customer's boarding pass that includes the flight details.</li>
                  <li>Flyin booking reference number.</li>
                </ul>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h2 style={{ 
                  color: "#0F4C81", 
                  fontSize: "20px", 
                  borderBottom: "1px solid #eaeaea",
                  paddingBottom: "8px",
                  marginBottom: "16px" 
                }}>
                  Steps to Claim Reimbursement
                </h2>
                <p style={{ marginBottom: "12px", lineHeight: "1.6", color: "#333333" }}>
                  Customers must follow these steps to claim their lounge access reimbursement:
                </p>
                <ol style={{ 
                  paddingLeft: "24px",
                  lineHeight: "1.6",
                  color: "#333333"
                }}>
                  <li>Collect all required documents, including the lounge/refreshment receipt, flight ticket/boarding pass, and Flyin booking reference.</li>
                  <li>Send a reply email to <a href="mailto:rest&refreshsupport@flyin.com" style={{ color: "#0F4C81", textDecoration: "none" }}>rest&refreshsupport@flyin.com</a> with the subject line "Rest & Refresh Reimbursement Claim"</li>
                  <li>Attach the required documents and mention your Flyin booking reference number.</li>
                  <li>The Flyin team will verify the submitted documents and process the reimbursement within 2 business days.</li>
                  <li>The reimbursement amount can be credited either to the customer's Flyin Wallet (OR) the original mode of payment within 72 business hours from Flyin side up to 7 business days based on your bank's processing.</li>
                </ol>
              </section>

              <section style={{ marginBottom: "32px" }}>
                <h2 style={{ 
                  color: "#0F4C81", 
                  fontSize: "20px", 
                  borderBottom: "1px solid #eaeaea",
                  paddingBottom: "8px",
                  marginBottom: "16px" 
                }}>
                  General Conditions
                </h2>
                <ul style={{ 
                  listStyleType: "disc", 
                  paddingLeft: "24px",
                  lineHeight: "1.6",
                  color: "#333333"
                }}>
                  <li>The program is non-transferable and applicable only to the original ticket holder.</li>
                  <li>Flyin reserves the right to reject claims if submitted documents are incomplete, illegible, or fraudulent.</li>
                  <li>Flyin reserves the right to modify, suspend, or terminate this program at any time without prior notice.</li>
                  <li>Any disputes related to the program will be subject to the jurisdiction of KSA/EG courts.</li>
                  <li>By availing of this program, the customer agrees to abide by these terms and conditions.</li>
                </ul>
              </section>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Footer */}
      <footer style={{ 
        backgroundColor: "#0F4C81", 
        color: "white", 
        padding: "24px 0",
        marginTop: "40px" 
      }}>
        <Container>
          <Row>
            <Col className="text-center">
              <p style={{ margin: "0" }}>© {new Date().getFullYear()} Flyin.com. All Rights Reserved.</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default RestRefreshTermsPage;